// GAVION call-brief-pipeline (demo / FakeRest): a deterministic brief from the lead's own fields, no model, no network.
const text = (v: unknown) => (typeof v === "string" ? v.trim() : "");

export function fakeCallBrief(company: Record<string, unknown>): {
  what_they_do: string;
  hook: string;
} {
  const name = text(company.name) || "L'entreprise";
  const trade = text(company.trade);
  const city = text(company.city);
  return {
    what_they_do: `${name} : ${trade ? trade.toLowerCase() : "entreprise de services"}${city ? ` à ${city}` : ""}.`,
    hook: "Demander comment ils gèrent les appels manqués pendant les chantiers, puis présenter la réceptionniste de Gavion.",
  };
}
